import { render, staticRenderFns } from "./CustomerConsentList.vue?vue&type=template&id=46e323d6&scoped=true"
import script from "./CustomerConsentList.vue?vue&type=script&lang=js"
export * from "./CustomerConsentList.vue?vue&type=script&lang=js"
import style0 from "./CustomerConsentList.vue?vue&type=style&index=0&id=46e323d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e323d6",
  null
  
)

export default component.exports